import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Timeline.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";

export default function Timeline() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const navigate = useNavigate();
  const toggleItem = (path) => {
    navigate(path);
  };
  const timelineItems = [
    {
      title: "Phase 1 : Technical Fundamentals",
      duration: "1 month",
      description:
        "Introduction to Basic Level Concepts and Operations with Appropriate Practical Utilities",
      badges: [
        "IDE Setup",
        "Intro to Technologies ",
        "Exposure to Tools/Platforms",
      ],
      path: "/month1",
    },
    {
      title: "Phase 2 : Intermediate Level Task Execution",
      duration: "3 months",
      description:
        " Technicalities and its real-time Execution Models.Domain-Specific Task Logic and Functions and its Implementations",
      badges: [
        "Scenario Based Task",
        "Personalized Feedback",
        "Periodic Assessment",
      ],
      path: "/month2",
    },
    {
      title:
        "Phase 3 : Real-Time Project Handling",
      duration: "2 months",
      description:
        "High end Architectural Requirement Executions and Technological integrations.Allocation of real time development flow/SDLC",
      badges: ["Real-TIme Development Flow", "Documentation", " Personalized Evaluation"],
      path: "/month3",
    },
  ];

  return (
    <section
      id="timeline"
      className="py-5 position-relative"
    >
      {/* Background video */}
      {/* <div className="program-bg  d-flex align-items-center">
        <video loop autoPlay muted playsInline>
          <source src="https://www.pexels.com/download/video/19419586/" />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container-fluid poistion-relative">
        {/* Section Heading */}
        <div className="row mb-5 position-relative">
          <div className="col-lg-8 mx-auto text-center">
            <h1 className="fw-bold" style={{ color: "rgb(108, 174, 225)" }}>
              Program Timeline
            </h1>
            <p
              className="fs-5 mt-5"
              style={{ color: "rgba(237, 240, 241, 1)" }}
            >
              A structured 6-month training and 1-year Job Guaranteed journey
              from beginner to Expertised IT Professional.
            </p>
          </div>
        </div>

        {/* Timeline Items */}
        <div className="row">
          <div className="col-lg-8 mx-auto ">
            {timelineItems.map((item, index) => (
              <div
                key={index}
                className="mb-4 timeline-item "
                data-aos="flip-up"
              >
                <div className=" shadow p-4 card-custom1">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <h4 className="text-info mb-0">{item.title}</h4>
                    <span
                      className={`badge ${
                        item.isSuccess ? "bg-success" : "bg-secondary"
                      } me-2`}
                    >
                      {item.duration}
                    </span>
                  </div>

                  <div className="ms-auto d-flex flex-wrap">
                    {" "}
                    <p className="text-light mb-3">{item.description}</p>
                    <button
                      className="ms-auto btn-primary-custom text-light"
                      onClick={() => toggleItem(item.path)}
                    >
                      Read More
                    </button>
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    {item.badges &&
                      item.badges.map((badge, badgeIndex) => (
                        <span key={badgeIndex} className="badge bg-secondary">
                          {badge}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
